import { useState, useEffect } from 'react';
import { createPublicClient, http, formatEther, formatUnits, createWalletClient, custom, parseEther, parseGwei } from 'viem';
import { coreDao } from 'viem/chains';

import './backhand_style.css';
import './backhand_media-queries.css';


import { useAccount } from 'wagmi';

import { Test_Bnb } from './Bnb_Test_Network';

import loading_gif from './images/loading_gif.gif';

import Pro_Trader_Con from './contracts/Bnb_Trade/Pro_Trader.json';
import Creator_Con from './contracts/Bnb_Trade/Creator_Con.json';

import TestUsdt_Token_Con from './contracts/TestUsdt_And_DateTime/TestUsdt_Token.json';
import DateTime_Con from './contracts/TestUsdt_And_DateTime/DateTimeContract.json';

import { data, UNSAFE_createClientRoutesWithHMRRevalidationOptOut } from 'react-router-dom';


export const DateTime = {
    address: "0xf16C1A2a9bed23522207f91b447FB6DC5D8d6Fb0",
    abi: DateTime_Con.abi
}
export const Usdt_Token = {
    address: "0x55d398326f99059ff775485246999027b3197955",
    // address: "0xF394027E6655Ca1A561aC2F6DfBb6c5D848486c9",
    abi: TestUsdt_Token_Con.abi
}

export const Pro_Trader = {
    address: "0x37D1377a0fae89B575BDf27d52F82C00Cec5D40C",
    abi: Pro_Trader_Con.abi
}
export const Creator = {
    address: "0x3c725352066dAaaea54E45FA8013883D6C2F1842",
    abi: Creator_Con.abi
}


const p_chain = Test_Bnb;

const p_transport = "https://bsc-dataseed.binance.org/";
// const p_transport = "https://bsc-testnet.bnbchain.org";//"https://rpc.sentio.xyz/bsc-testnet";

const client = createPublicClient({
  chain: p_chain,
  transport: http(p_transport)
});

 
let Core_deceimals = Number(4);//2);
let Usdt_deceimals = Number(2);//3);

// let Symbol = "DAI";
// let Symbol = "CORE";
let Symbol = "Usdt";

let url = "https://fxcprofit.pro/";
// let url = "http://localhost:3000/";


let type_url = "https://bscscan.com/address/";
// let type_url = "https://testnet.bscscan.com/address/";

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//-------------------------------------------For_Nutral-------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function Loading_Component(props) {

    return (
        <>
            <img style={{width: '15px', height: '15px'}} src={loading_gif} alt="loading" />
        </>
    );
}
function Card_LC(props) {

    return (
        <>
            <img style={{width: '15px', height: '15px'}} src={loading_gif} alt="loading" />
        </>
    );
}

//-----Search_Function_Area------------------

export async function Copy(data, showAlert) {
    if (data === '') {}
    else {
        navigator.clipboard.writeText(data);
        showAlert(data + " Copied!...", 'success', true);
    }
}
export async function Check_Add(data, showAlert) {
    if (data === '') {}
    else {
        navigator.clipboard.writeText(type_url + "" + data);
        showAlert(type_url + "" + data + " Copied!...", 'success', true);
    }
} 


async function timestamp_from_solidtiy_to_javascript(solidityTs) {  
    // 1. Convert seconds to milliseconds (10 digits -> 13 digits) (timestamp from solidity to )
    let date = new Date(solidityTs * 1000); 
    return date;
}
async function timestamp_to_solidtiy_from_javascript(javascriptTs) {  
    // 3. Convert back to seconds for Solidity compliance
    return Math.floor(javascriptTs.getTime() / 1000); 
}

export async function GetTimestamp() {
    let returned_timestamp;
    
    let cur_timestamp = await client.readContract({
        address: DateTime.address,
        abi: DateTime.abi,
        functionName: "_now"
    });
    // console.log("cur_timestamp: " + cur_timestamp);
    // console.log(" ");

    //let add_days = 6; //--1
    //let add_days = 12; //--2
    //let add_days = 15; //--3
    // let add_days = 17; //--4
    // let add_days = 19; //--5
    // let add_days = 21; //--6
    // let add_days = 23; //--7
    // let add_days = 25; //--8
    // let add_days = 27; //--9
    // let add_days = 29; //--10
    // let add_days = 31; //--11
    // let add_days = 33; //--12
    // let add_days = 35; //--13
    // let add_days = 37; //--14
    // let add_days = 39; //--15    
    // let add_days = 41; //--16
    // let add_days = 43; //--17
    // let add_days = 45; //--18
    // let add_days = 47; //--19
    // let add_days = 49; //--20 
    // let add_days = 51; //--21
    // let add_days = 53; //--22
    // let add_days = 55; //--23
    // let add_days = 57; //--24 
    // let add_days = 149; //--
    // let add_days = 150; //--
    // let add_days = 152;


    //-----//
    //-----//
    //-----//

    // let add_days = 1;
    // let add_days = 2;

    // let add_days = 3;
    // let add_days = 4;
    // let add_days = 36;

    // let add_days = 37;
    // let add_days = 38;

    // let add_days = 39;
    // let add_days = 40;

    // let add_days = 148;
    // let add_days = 149;

    // let add_days = 150;
    // let add_days = 151;

    // let add_days = 162;
    // let add_days = 174;

    
    // cur_timestamp = await client.readContract({
    //     address: DateTime.address,
    //     abi: DateTime.abi,
    //     functionName: "addDays",
    //     args: [cur_timestamp, add_days]
    // });


    returned_timestamp = cur_timestamp;

    return returned_timestamp;
}
export async function GetDateTime(timestamp) {

    let tp_into_dt = await client.readContract({
        address: DateTime.address,
        abi: DateTime.abi,
        functionName: "timestampToDateTime",
        args: [timestamp]
    });

    let _DateTime = (tp_into_dt[2] + "-" + tp_into_dt[1] + "-" + tp_into_dt[0] + " || " + tp_into_dt[3] + ":" + tp_into_dt[4] + " :" + tp_into_dt[5]);

    // console.log(DateTime);
    return _DateTime;
}
export async function Convert_DateTime_Timestamp_Into_Date_Timestamp(timestamp) {

    let tp_into_dt = await client.readContract({
        address: DateTime.address,
        abi: DateTime.abi,
        functionName: "timestampToDateTime",
        args: [timestamp]
    });

    let date_timestamp = await client.readContract({
        address: DateTime.address,
        abi: DateTime.abi,
        functionName: "timestampFromDate",
        args: [tp_into_dt[0], tp_into_dt[1], tp_into_dt[2]]
    });

    return date_timestamp;

}

export async function Day_Diff_In_Timestamp(from_timestamp, to_timestamp) {

}

async function addDays(ts, days) {
    const date = new Date(ts);
    date.setDate(date.getDate() + days);
    return date.getTime(); // Returns the new timestamp in milliseconds
}


//---------

// // solidityTimestamp comes from your contract (10 digits / seconds)
// const solidityTimestamp = 1785638400; 

function addDaysToSolidityExpiry(solidityTs, days) {
  // 1. Convert seconds to milliseconds (10 digits -> 13 digits)
  let date = new Date(solidityTs * 1000); 
  
  // 2. Safely add the days
  date.setDate(date.getDate() + days); 
  
  // 3. Convert back to seconds for Solidity compliance
  return Math.floor(date.getTime() / 1000); 
}

// const newSolidityTimestamp = addDaysToSolidityExpiry(solidityTimestamp, 1);
// console.log(newSolidityTimestamp); // Correctly returns the timestamp for 03-08-2026


//---------


export function GetDate(timestamp) {
    
    let dt = new Date(timestamp);
    let datetime = [];

    datetime[1] = dt.getFullYear();
    datetime[2] = (dt.getMonth() + 1);
    datetime[3] = dt.getDate();

    return (datetime)
}
export function Sub_Variable(data) {
    //console.log("_____________________");
    //console.log(data);
    if(data) {//(data !== "" || data !== undefined) {
        // let var_data = data.substring(0, 10) + "......" + data.substring(31, 41);
        let var_data = data.substring(0, 6) + "......" + data.substring(37, 42);//41);
        //console.log(var_data);
        return var_data;
    }
    else {
        return "";
    }
}
export function Sub_Ref_Variable(data) {
    //console.log("_____________________");
    //console.log(data);
    if(data) {//(data !== "" || data !== undefined) {
        let var_data = data.substring(0, 11) + "..." + data.substring(24, 34);//27, 34);
        //console.log(var_data);
        return var_data;
    }
    else {
        return "";
    }
}

function Format_Core(data) {
    return Number(formatEther(BigInt(data))).toFixed(Core_deceimals);
}
function Format_Usdt(data) {
    return Number(formatEther(BigInt(data))).toFixed(Usdt_deceimals);
}
function Format_Usdt_Without_Decimals(data) {
    return Number(formatEther(BigInt(data)));
}

function Format_Core_For_Fix(data) {
    return Number(formatEther(BigInt(data))).toFixed(Number(2));
}


function Format_PraseUsdt(data) {
    return BigInt(parseEther(data));
}
function IsSymbol() {
    return (
        <>
            {
                Symbol === "DAI" ? (
                    <>{Symbol}</>
                ) : (
                    <> {Symbol}</>
                )
            }
        </>
    )
}

async function Format_UTC(data) {
    //console.log(data);
    let dt_arr = new Date(Number(String(data) + String("000")));
    //console.log(dt_arr);
    // let datetime = dt_arr.toLocaleString();
    let datetime = dt_arr.toLocaleDateString();
    
    //console.log(datetime);
    return datetime;
}

function Is_Value_Format_Without_Symbol(data) {
    return (
        <>
            {Format_Core(data)}
        </>
    );
}
function Is_Rank(pack_no) {
    return (
        <>
            {"Rank : " + (pack_no)}
        </>
    );
} 

async function Return_Page_Settings(Total_No) {
    try {
        let Total_No_Length = Number(String(Total_No).length);

        let Num = "";
        for(let i = 1; i <= Total_No_Length; i++) {
            if(Number(i) === Number(1)) {
                Num = "0";
            }   
            else if (Number(i) > Number(1)) {
                Num += String(Number(i-1));
            }
        }

        //console.log(" ");
        //console.log("----------------");
        //console.log(" ");
        //console.log(String(Total_No));
        //console.log(String(Num) + " Length : " + Total_No_Length);
        //console.log(" ");

        if(Number(Total_No) > 9) {
            //console.log(Total_No.toString()[1]); //0 = 1 1 = 0
            //console.log(Total_No.toString().charAt(0)); //0 = 1 1 = 0  
            //console.log(String(Total_No)[String(Total_No.length + 1)] + " +|+ " + String(Total_No)[1] ); //0 = 1 1 = 0  

            let Second_Last = Number(Total_No_Length-2);
            let First_Last = Number(Total_No_Length-1);
            let Total_Last = Number(String(Second_Last) + "" + String(First_Last));
            //console.log("Second_Last : " + Second_Last + " +|+ First_Last : " + First_Last);
            //console.log("Total_Last : " + Total_Last);     
            //console.log(" ");               

            let Second_Last_Value = String(Total_No)[Second_Last];
            let First_Last_Value = String(Total_No)[First_Last];
            let Total_Last_Value = Number(String(Second_Last_Value) + "" + String(First_Last_Value));
            //console.log("Second_Last Value : " + Second_Last_Value + " +|+ First_Last Value : " + First_Last_Value);
            //console.log("Total_Last_Value : " + Total_Last_Value);

            let TLV = Number(Total_Last_Value);

            let Second_Last_Plus_Value;
            if(Number(TLV) === Number(0) || Number(TLV) === Number(20) || Number(TLV) === Number(40) || Number(TLV) === Number(60) || Number(TLV) === Number(80) || Number(TLV) === Number(100)) {
                Second_Last_Plus_Value = 0;
            }
            if(Number(TLV) === Number(10) || Number(TLV) === Number(30) || Number(TLV) === Number(50) || Number(TLV) === Number(70) || Number(TLV) === Number(90)) {
                Second_Last_Plus_Value = 1;
            }
            else {
                if     (Number(TLV) > Number(0) && Number(TLV) < Number(10)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(10) && Number(TLV) < Number(20)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(20) && Number(TLV) < Number(30)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(30) && Number(TLV) < Number(40)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(40) && Number(TLV) < Number(50)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(50) && Number(TLV) < Number(60)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(60) && Number(TLV) < Number(70)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(70) && Number(TLV) < Number(80)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(80) && Number(TLV) < Number(90)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(90) && Number(TLV) < Number(100)) { Second_Last_Plus_Value = String(0); }
            }

            let First_Last_Plus_Value;
            if(Number(First_Last_Value) === Number(0)) { First_Last_Plus_Value = String(0); }
            else if(Number(First_Last_Value) === Number(1)) { First_Last_Plus_Value = String(9); }
            else if(Number(First_Last_Value) === Number(2)) { First_Last_Plus_Value = String(8); }
            else if(Number(First_Last_Value) === Number(3)) { First_Last_Plus_Value = String(7); }
            else if(Number(First_Last_Value) === Number(4)) { First_Last_Plus_Value = String(6); }
            else if(Number(First_Last_Value) === Number(5)) { First_Last_Plus_Value = String(5); }
            else if(Number(First_Last_Value) === Number(6)) { First_Last_Plus_Value = String(4); }
            else if(Number(First_Last_Value) === Number(7)) { First_Last_Plus_Value = String(3); }
            else if(Number(First_Last_Value) === Number(8)) { First_Last_Plus_Value = String(2); }
            else if(Number(First_Last_Value) === Number(9)) { First_Last_Plus_Value = String(1); }

            let Total_Last_Plus_Value = Number(String(Second_Last_Plus_Value) + "" + String(First_Last_Plus_Value));

            //console.log(" ");
            
            //console.log("Second_Last_Plus_Value : " + Second_Last_Plus_Value + " +|+ First_Last_Plus_Value : " + First_Last_Plus_Value);
            //console.log("Total_Last_Plus_Value : " + Total_Last_Plus_Value);
            
            let Total_No_Updated = Number(Number(Total_No) + Number(Total_Last_Plus_Value));

            //console.log(" ");
            //console.log("Total_No_Updated : " + Total_No_Updated);

            let Total_Page = Number(Number(Total_No_Updated) / 20);
            //console.log(" ");
            //console.log("Total_Page : " + Total_Page);
            
            return Total_Page;
            
        }
        else if(Number(Total_No) < 10) {

            let First_Last = Number(Total_No_Length-1);
            //console.log("First_Last : " + First_Last);

            let First_Last_Value = String(Total_No)[First_Last];
            //console.log("First_Last Value : " + First_Last_Value);

            let First_Last_Plus_Value;

            if(Number(First_Last_Value) === Number(0)) { First_Last_Plus_Value = String(0); }
            else if(Number(First_Last_Value) === Number(1)) { First_Last_Plus_Value = String(9); }
            else if(Number(First_Last_Value) === Number(2)) { First_Last_Plus_Value = String(8); }
            else if(Number(First_Last_Value) === Number(3)) { First_Last_Plus_Value = String(7); }
            else if(Number(First_Last_Value) === Number(4)) { First_Last_Plus_Value = String(6); }
            else if(Number(First_Last_Value) === Number(5)) { First_Last_Plus_Value = String(5); }
            else if(Number(First_Last_Value) === Number(6)) { First_Last_Plus_Value = String(4); }
            else if(Number(First_Last_Value) === Number(7)) { First_Last_Plus_Value = String(3); }
            else if(Number(First_Last_Value) === Number(8)) { First_Last_Plus_Value = String(2); }
            else if(Number(First_Last_Value) === Number(9)) { First_Last_Plus_Value = String(1); }

            let Total_No_Updated;
            let Total_Page;
            if(Number(First_Last_Value) === Number(0)) {
                Total_No_Updated = Number(Number(Total_No) + Number(First_Last_Plus_Value) + Number(20));
                Total_Page = 1;
            }
            else if(Number(First_Last_Value) > Number(0)) {
                Total_No_Updated = Number(Number(Total_No) + Number(First_Last_Plus_Value) + Number(10));
                Total_Page = 1;
            }

            //console.log(" ");
            //console.log("Total_No_Updated : " + Total_No_Updated);
            //console.log(" ");
            //console.log("Total_Page : " + Total_Page);

            return Total_Page;

        }
    }
    catch(error) {
        console.log(error);
    }
}
const Custom_Pre_Total_Roi_Calculate = async(total_pack_amt_) => {
    try {
        let Pack = total_pack_amt_;

        let Total_Return_By_3_Per = BigInt(0);
        let Total_Roi = BigInt(0);
        let Total_Withdraw = BigInt(0);

        for(let i = Number(1); i <= Number(76); i++) {
            if(Number(i) < Number(76)) {
                let Per_3 = BigInt(BigInt(BigInt(Pack) * BigInt(3)) / BigInt(100));
                let Per_1 = BigInt(BigInt(BigInt(Pack) * BigInt(1)) / BigInt(100));
                let Withdraw = BigInt(BigInt(Per_3) + BigInt(Per_1));

                // console.log("Pack: " + BigInt(Pack) + " 3%: " + BigInt(Per_3) + " 1%: " + BigInt(Per_1) + " Withdraw: " + BigInt(Withdraw));
                Pack -= BigInt(Per_3);

                Total_Return_By_3_Per += BigInt(Per_3);
                Total_Roi += BigInt(Per_1);
                Total_Withdraw += BigInt(Withdraw);
            }
            else if(Number(i) === Number(76)) {
                let Per_3 = BigInt(0);
                let Per_1 = BigInt(0);
                let Withdraw = BigInt(BigInt(Pack));

                // console.log("Pack: " + BigInt(Pack) + " 3%: " + BigInt(Per_3) + " 1%: " + BigInt(Per_1) + " Withdraw: " + BigInt(Withdraw));
                Pack -= BigInt(Pack);

                Total_Return_By_3_Per += BigInt(Per_3);
                Total_Roi += BigInt(Per_1);
                Total_Withdraw += BigInt(Withdraw);
            }
        }
        return Total_Withdraw;
    }
    catch(error) {
        console.log(error);
    }
}


const Custom_Pre_Total_Roi_Calculate_Detail = async(total_pack_amt_, to_count_, D1_Pack, D1_Per_3, D1_Per_1, D1_Withdraw) => {
    try {
        let Pack = BigInt(total_pack_amt_);

        let Per_3 = BigInt(0);
        let Per_1 = BigInt(0);
        let Withdraw = BigInt(BigInt(Pack));

        for(let i = Number(1); i <= Number(to_count_); i++) {
            if(Number(i) < Number(76)) {
                Per_3 = BigInt(BigInt(BigInt(Pack) * BigInt(3)) / BigInt(100));
                Per_1 = BigInt(BigInt(BigInt(Pack) * BigInt(1)) / BigInt(100));
                Withdraw = BigInt(BigInt(Per_3) + BigInt(Per_1));

              //console.log("Pack: " + BigInt(Pack) + " 3%: " + BigInt(Per_3) + " 1%: " + BigInt(Per_1) + " Withdraw: " + BigInt(Withdraw));
                Pack -= BigInt(Per_3);
            }
            else if(Number(i) === Number(76)) {
                Per_3 = BigInt(0);
                Per_1 = BigInt(0);
                Withdraw = BigInt(BigInt(Pack));

              //console.log("Pack: " + BigInt(Pack) + " 3%: " + BigInt(Per_3) + " 1%: " + BigInt(Per_1) + " Withdraw: " + BigInt(Withdraw));
                Pack -= BigInt(Pack);
            }            
        }
        D1_Pack = Pack;
        D1_Per_3 = Per_3;
        D1_Per_1 = Per_1;
        D1_Withdraw =  Withdraw;  
        
        // return (Pack, Per_3, Per_1, Withdraw);
    }
    catch(error) {
        console.log(error);
    }
}


//-------------After-Login-----------------

{/*----DashBoard--------*/}

export function DashBoard_Form(props) {

    //---props.ReLoad();

    const [Wallet_Balance, SetWallet_Balance] = useState(Number(0));
    const [Cur_Pack, SetCur_Pack] = useState(Number(0));

    const [Roi_Count, SetRoi_Count] = useState(Number(0));
    const [Roi_Total_Earn, SetRoi_Total_Earn] = useState(Number(0));

    const [Ref_Team, SetRef_Team] = useState(Number(0));
    const [Ref_Total_Earn, SetRef_Total_Earn] = useState(Number(0));

    //---

    const [Should_Disable, SetShould_Disable] = useState(true);

    const [Num_Value, SetNum_Value] = useState("");
    const [Num_Error, SetNum_Error] = useState("");

    const [IsReTopUp_Btn_Disabled, SetIsReTopup_Btn_Disabled] = useState(true);

    const Num_handleChange = (e) => {
        const val = e.target.value;
        SetNum_Value(val);
       // console.log(val);

        const num = Number(val);

        if(num === "") {
            SetNum_Error("");
            SetIsReTopup_Btn_Disabled(true);
        }
        else {
            if (Number(Cur_Pack) >= Number(51)) {
                if(Number(num) >= Number(Cur_Pack)) {
                    
                    if(Number(num) <= Number(110)) {
                        if(Number(Wallet_Balance) >= Number(num)) {
                            SetNum_Error("");
                            SetIsReTopup_Btn_Disabled(false);
                        }
                        else {                        
                            SetNum_Error("Your Wallet Doesn't Have Enough Balance!.");
                            SetIsReTopup_Btn_Disabled(true);
                        }
                    }
                    else {                        
                        SetNum_Error("Cannot be Above $110.");
                        SetIsReTopup_Btn_Disabled(true);
                    }
                }
                else if(Number(num) < Number(Cur_Pack)) {
                    SetNum_Error("InVaild ReTopUp Eligible Amount, It Needs to be Equal Or Above Your Previous Pack Amt.");
                    SetIsReTopup_Btn_Disabled(true);
                }
            } 
            else if(Number(Cur_Pack) < Number(51)) {                
                if(Number(num) >= Number(51)) {               
                    if(Number(num) <= Number(110)) {     
                        if(Number(Wallet_Balance) >= Number(num)) {
                            SetNum_Error("");
                            SetIsReTopup_Btn_Disabled(false);
                        }
                        else {                        
                            SetNum_Error("Your Wallet Doesn't Have Enough Balance!.");
                            SetIsReTopup_Btn_Disabled(true);
                        }
                    }
                    else {                        
                        SetNum_Error("Cannot be Above $110.");
                        SetIsReTopup_Btn_Disabled(true);
                    }
                }
                else if(Number(num) < Number(51)) {
                    SetNum_Error("InVaild ReTopUp Eligible Amount, It Needs to be Equal or Above $51.");
                    SetIsReTopup_Btn_Disabled(true);
                }
            } 
        }         
    };
    
    const Load_Data = async() => {
        try {
           // console.log(" ");
           // console.log(props.ID_);
            
            let Wall_Balance = await client.readContract({
                address: Usdt_Token.address,
                abi: Usdt_Token.abi,
                functionName: "balanceOf",
                args: [props.address]
            });
            let Dashboard_Detail = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetDashboard_Detail",
                args: [props.ID_]
            });
            let ID_Count_Pack_Amt = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetID_Count_Pack_Amt",
                args: [props.ID_, Number(Dashboard_Detail[0])]
            });


            // console.log(" ");
            // console.log("Dashboard_Detail: ");
            // console.log(Dashboard_Detail);
            // console.log(" ");
            // console.log("Wall_Balance: ");
            // console.log(Wall_Balance);
            // console.log(" ");

            SetWallet_Balance(Format_Usdt(BigInt(Wall_Balance)));
            SetCur_Pack(Format_Usdt(BigInt(ID_Count_Pack_Amt)));

            SetRoi_Count(Number(Dashboard_Detail[0]));
            SetRoi_Total_Earn(Format_Usdt(BigInt(Dashboard_Detail[1])));

            SetRef_Team(Number(Dashboard_Detail[2]));
            SetRef_Total_Earn(Format_Usdt(BigInt(Dashboard_Detail[3])));

            //----

            let Is_Eligible_To_ReTopUp = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetIs_Eligible_To_ReTopUp",
                args: [props.ID_]
            });
           // console.log("Is_Eligible_To_ReTopUp: ");
           // console.log(Is_Eligible_To_ReTopUp);
            if(Is_Eligible_To_ReTopUp === true) {
                SetShould_Disable(false);
            }
            else if(Is_Eligible_To_ReTopUp === false) {
                SetShould_Disable(true);
            }
            
            SetIsReTopup_Btn_Disabled(true);

        }
        catch(error) {
            console.log(error);

            SetWallet_Balance(Format_Usdt(Number(0)));
            SetCur_Pack(Format_Usdt(Number(0)));
            
            SetRoi_Count(Number(0));
            SetRoi_Total_Earn(Format_Usdt(Number(0)));

            SetRef_Team(Number(0));
            SetRef_Total_Earn(Format_Usdt(Number(0)));

            SetShould_Disable(true);
        }
    }
    
    const ReTopUp_Click = async() => {
        try {                       
            props.SetLoadingModal(true, true);
            if (window.ethereum) {
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });
        
                //console.log("WalletClient");
                //console.log(walletClient);

                let usdt_amount = parseEther(String(Num_Value));

               // console.log("usdt_amount: ");
               // console.log(usdt_amount);


                props.SetLoadingModal(true, true);
                // let User_Usdt_BalanceOf = await client.getBalance({address: address});

                let Usdt_Usdt_BalanceOf = await client.readContract({
                    address: Usdt_Token.address,
                    abi: Usdt_Token.abi,
                    functionName: "balanceOf",
                    args: [props.address]
                });
                // console.log(Number(Usdt_Usdt_BalanceOf));

                // console.log('address: ' + address + ' id_: ' + id_ + " Upline_ID: " + Upline_ID);

                
                // let cur_timestamp = await GetTimestamp();

                // //--

                if(BigInt(Usdt_Usdt_BalanceOf) >= BigInt(usdt_amount)) {
                    // console.log(BigInt(Usdt_Usdt_BalanceOf) + " is greater than " + BigInt(usdt_amount))
                    try {
                        props.SetLoadingModal(true, false);
                        
                        let usdt_request = await walletClient.writeContract({
                            address: Usdt_Token.address,
                            abi: Usdt_Token.abi,
                            functionName: "approve",
                            args: [Pro_Trader.address, BigInt(usdt_amount)],
                            
                            // maxPriorityFeePerGas: BigInt(60e9), // required minimum
                            // maxFeePerGas: BigInt(150e9),   
                        });

                        props.SetLoadingModal(true, true);
                        // console.log("usdt_request: ");
                        // console.log(usdt_request);
                    
                        const usdt_transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: usdt_request});
                
                        if(usdt_transaction.status === "success") {
                            props.SetLoadingModal(true, false);

                            try {
                                let retopup_request = await walletClient.writeContract({
                                    address: Pro_Trader.address,
                                    abi: Pro_Trader.abi,
                                    functionName: "ReTopUp_ID",
                                    args: [props.ID_, BigInt(usdt_amount)]//, Number(cur_timestamp)],
                                });

                                props.SetLoadingModal(true, true);
                                // console.log("retopup_request: ");
                                // console.log(retopup_request);
                            
                                const retopup_transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: retopup_request});
                        
                                if(retopup_transaction.status === "success") {
                                    props.SetLoadingModal(false, false);
                                    props.showAlert("ID ReTopUped!...", "success", true);
                                    setTimeout(() => {
                                        //---SetLoading---
                                        props.ReLoad();
                                    }, [2000]);                                
                                }
                                else {
                                    props.SetLoadingModal(false, false);
                                    props.showAlert("ID ReTopUp Transaction Reverted!...", "danger", true);
                                }
                            }
                            catch(error) {
                                props.SetLoadingModal(false, false);
                                props.showAlert("ID ReTopUp Transaction Reverted!...", "danger", true);
                            }
                        }
                        else {
                            props.SetLoadingModal(false, false);
                            props.showAlert("Usdt Approve Transaction Reverted!...", "danger", true);
                        }    
                    
                    }
                    catch(error) {
                        console.log(error);
                        props.SetLoadingModal(false, false); 
                        props.showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                else {
                    props.SetLoadingModal(false, false);
                    props.showAlert("Insufficient Balance!...", "danger", true);
                }
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }

    useEffect(() => {
       // console.log("DashBoard Form: props.ID_: " + props.ID_);
       // console.log("DashBoard Form: props.Is_State_Change: " + props.Is_State_Change);
        Load_Data();
    }, [props.ID_, props.Is_State_Change]);

    return (
        <>
            <div class="cards">
                <div class="card-single">
                    <div class="card-single-header">
                        <h3>Slot</h3>
                    </div> 
                    <div class="card-bodys-miiddle">
                        <div class="card-calc">
                            <h3>Wallet</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>{Wallet_Balance}</span>
                            </div> 
                        </div>
                        <div class="card-calc">
                            <h3>Current Pack</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>{Cur_Pack}</span>
                            </div> 
                        </div>
                    </div>

                    <div class="card-single-last">
                        {/* <button style={{background: "grey"}}>Check<span></span></button>         */}
                    </div>
                </div>
                <div class="card-single">
                    <div class="card-single-header">
                        <h3>Activate Slot</h3>
                    </div> 

                            
                                <div class="card-bodys-miiddle">
                                    <div class="card-calc">
                                        <h3>Min</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>20</span>
                                        </div>                             
                                    </div>
                                    
                                    <div class="card-calc">
                                        <h3>Wallet</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>{Wallet_Balance}</span>
                                        </div> 
                                    </div>

                                    <div class="card-calc">
                                        <h3>Max</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>110</span>
                                        </div> 
                                    </div>
                                </div>
                                <div class="card-bodys-miiddle">
                                    <div class="f-card-funds">                                        
                                    {
                                        Should_Disable === false ? (
                                            <input class="form-input" type="number" id="number" name="number" placeholder="Enter Amount" maxlength="3" value={Num_Value} onChange={Num_handleChange} required/>
                                        ) : (
                                            <input class="form-input" type="number" id="number" name="number" placeholder="Enter Amount" maxlength="3" value={""} required style={{background: 'grey'}}/>
                                        )
                                    }
                                    </div>
                                </div>                                
                                <div class="card-bodys-miiddle">
                                    <div style={{textAlign: 'center'}}>
                                        {Num_Error && <p style={{ color: "red" }}>{Num_Error}</p>} 
                                    </div>
                                </div>
                            
                        
                    

                    <div class="card-single-last">
                        {
                            IsReTopUp_Btn_Disabled === true ? (
                                <>
                                    <button style={{background: "grey"}}>Re-Top-Up<span></span></button>
                                </>
                            ) : IsReTopUp_Btn_Disabled === false ? (
                                <>
                                    <button onClick={() => {
                                        ReTopUp_Click();
                                    }}>Re-Top-Up<span></span></button>                                
                                </>
                            ) : (
                                <></>
                            )
                        }
                    </div>
                </div>
                <div class="card-single">
                    <div class="card-single-header">
                        <h3>Total Roi Bonus</h3>
                    </div> 
                    <div class="card-bodys-miiddle">
                        <div class="card-calc">
                            <h3>Roi Count</h3>
                            <div class="grid-detail">
                                <span>{Roi_Count}</span>
                            </div> 
                        </div>
                        <div class="card-calc">
                            <h3>Total Earn</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>{Roi_Total_Earn}</span>
                            </div> 
                        </div>
                    </div>
                    <div class="card-single-last">
                        {/* <button style={{background: 'grey'}}>Check<span class=""></span></button> */}
                    </div>
                </div>
                <div class="card-single">
                    <div class="card-single-header">
                        <h3>Referral Bonus</h3>
                    </div> 
                    <div class="card-bodys-miiddle">
                        <div class="card-calc">
                            <h3>Referral Team</h3>
                            <div class="grid-detail">
                                <span>{Ref_Team}</span>
                            </div> 
                        </div>
                        <div class="card-calc">
                            <h3>Total Earn</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>{Ref_Total_Earn}</span>
                            </div> 
                        </div>
                    </div>
                    <div class="card-single-last">
                        {/*<button style={{background: 'grey'}}>Check<span class=""></span></button>*/}
                    </div>
                </div>
                {/* <div class="card-single">
                    <div class="card-single-header">
                        <h3>Total Bonus</h3>
                    </div> 
                    <div class="card-bodys-miiddle">
                        <div class="card-calc">
                            <h3>Claimed</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>20</span>
                            </div> 
                        </div>
                        <div class="card-calc">
                            <h3>Claimable</h3>
                            <div class="grid-detail">
                                <span>$</span>
                                <span>2000</span>
                            </div> 
                        </div>
                    </div>
                    <div class="card-single-last">
                        <button>Check<span class=""></span></button>
                    </div>
                </div> */}
            </div>
        </>
    );
}

{/*----Roi_Income--------*/}

export function Roi_Income_Form(props) {

    //---Roi_Card_Area---\\

    const [Total_Roi_Count, SetTotal_Roi_Count] = useState(Number(1));
    const [Total_Roi_Count_Detail, SetTotal_Roi_Count_Detail] = useState([]);

    const [Cur_Roi_Selected, SetCur_Roi_Selected] = useState(Number(1));
    const [Cur_Roi_Selected_Total_Days, SetCur_Roi_Selected_Total_Days] = useState(Number(0));
    const [Cur_Roi_Selected_Claimable, SetCur_Roi_Selected_Claimable] = useState(Number(0));

    const [Should_Disable, SetShould_Disable] = useState(true);

    //----------------

    const [Total_Topup, SetTotal_Topup] = useState(Number(0));

    const [Selected_Topup, SetSelected_Topup] = useState(Number(0));
    const [Total_Count, SetTotal_Count] = useState(Number(0));
    
    const [Is_Selected_Roi_Completed, SetIs_Selected_Roi_Completed] = useState(false);

    const [Total_Page, SetTotal_Page] = useState(Number(0));
    const [Current_Page, SetCurrent_Page] = useState(Number(0));

    const [R_Detail, SetR_Detail] = useState([]);

    const [Roi_Is, SetRoi_Is] = useState("");
    const [Roi_Detail, SetRoi_Detail] = useState([]);

    const [Roi_Count_Is, SetRoi_Count_Is] = useState("");
    const [Roi_Count_Detail, SetRoi_Count_Detail] = useState([]);

    //---
    
    const [Claim_is_Click_So_ReLoad, SetClaim_is_Click_So_ReLoad] = useState(false);

        
    const Current_Page_Detail = async(cur_page, Detail, last_count, topup) => {
        try {            
            SetCurrent_Page(cur_page);

            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            //console.log(from + " from");
            //console.log(to + " to");

           
            SetRoi_Count_Is(Loading_Component());
            SetRoi_Count_Detail([]);

            // console.log(R_Detail);

            let Arr = [];

            for(let i = from; i <= to; i++) {

                if(Number(i) > Number(last_count)) { break; }

                // console.log("R_Detail: ");
                // console.log(R_Detail[(i-1)]);
                Arr.push({
                    sr: Number(i),
                    claimable: Detail[(i-1)].claimable,
                    datetime: Detail[(i-1)].roi_date,
                    status: Detail[(i-1)].status,
                });
            }
            
            SetRoi_Count_Is("");
            SetRoi_Count_Detail(Arr);
            
        }
        catch(error) {
            console.log(error);
            SetRoi_Count_Is("");
            SetRoi_Count_Detail([]);            
        }
    }
    const Next = async() => {
        let nextpage = Number(Number(Current_Page) + Number(1));
        if(Number(nextpage) > Number(Total_Page)) {}
        else if(Number(nextpage) <= Number(Total_Page)) {            
            Current_Page_Detail(Number(nextpage), R_Detail, Total_Count, Selected_Topup); 
        }
    }
    const Pre = async() => {
        let prepage = Number(Number(Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {}
        else if(Number(prepage) >= Number(1)) {
            Current_Page_Detail(Number(prepage), R_Detail, Total_Count, Selected_Topup); 
        }
    }

    const Roi_Count_Clicked = async(topup, total_roi_days, cur_date_timestamp, last_time_claimed_date_timestamp_) => {
        try {
            SetSelected_Topup(Number(0));
            SetTotal_Count(Number(0));
            SetR_Detail([]);

            let ID_Activation_Date_Timestamp = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetID_Activation_Date_Timestamp",
                args: [props.ID_, Number(topup)]
            });
            let ID_Count_Pack_Amt = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetID_Count_Pack_Amt",
                args: [props.ID_, Number(topup)]
            });

           // console.log("ID_Activation_Date_Timestamp: " + ID_Activation_Date_Timestamp)
           // console.log("ID_Activation_Date_UTC: " + await Format_UTC(ID_Activation_Date_Timestamp));
           // console.log("ID_Activation_DateTime: " + await GetDateTime(ID_Activation_Date_Timestamp));


            //--(convert this to datetime useing contract to datetime.)

            // ID_Activation_Date_Timestamp = await Convert_DateTime_Timestamp_Into_Date_Timestamp(ID_Activation_Date_Timestamp);
            // console.log("ID_Activation_Date_Timestamp:               " + ID_Activation_Date_Timestamp);

            // console.log(" ");
            // console.log(" topup: "+topup+" total_roi_days: "+total_roi_days+" cur_date_timestamp: "+cur_date_timestamp+" last_time_claimed_date_timestamp_: "+last_time_claimed_date_timestamp_);
            // console.log(" ");

            let Detail = [];

            let last_total_count_ = 0;

           // console.log()
            for(let i = 1; i <= Number(total_roi_days); i++) {
                let date_timestamp = await addDaysToSolidityExpiry(Number(ID_Activation_Date_Timestamp), Number(i));
                let datetime = await Format_UTC(date_timestamp);
                let claimable_ = BigInt(BigInt(ID_Count_Pack_Amt) * BigInt(1) / BigInt(100));
                let status_;
                
                // console.log(" i : "+i+" date_timestamp: "+date_timestamp+" datetime: "+datetime+" claimable_: "+claimable_+" status_: "+status_);

                // console.log("date_timestamp: " +date_timestamp+ " || cur_date_timestamp: "+cur_date_timestamp);
                // console.log("Format_UTC: " +await Format_UTC(date_timestamp)+ " || Format_UTC: "+await Format_UTC(cur_date_timestamp));
                
                // console.log("date_timestamp: " +date_timestamp);
                // console.log("cur_date_timestamp: "+cur_date_timestamp);
                

                if(Number(date_timestamp) <= Number(cur_date_timestamp)) {
                   // console.log("date_timestamp <= cur_date_timestamp");

                    if(Number(date_timestamp) <= Number(last_time_claimed_date_timestamp_)) {
                        status_ = "Claimed.";
                    }
                    else if(Number(date_timestamp) > Number(last_time_claimed_date_timestamp_)) {
                        status_ = "UnClaimed.";
                    }
                    
                    // console.log(" i : "+i+" date_timestamp: "+date_timestamp+" datetime: "+datetime+" claimable_: "+claimable_+" status_: "+status_);

                    Detail.push({
                        days: Number(i),
                        claimable: Format_Usdt(claimable_),
                        roi_date: datetime,
                        status: status_
                    });
                    
                    // console.log("Detail: ");
                    // console.log(Detail);

                }
                else if(Number(date_timestamp) > Number(cur_date_timestamp)) {
                   // console.log("date_timestamp > cur_date_timestamp");
                    last_total_count_ = Number(i-1);
                    break;
                }

                if(Number(i) === Number(total_roi_days)) {
                    last_total_count_ = Number(i);
                } 
               // console.log(" ");   
            }

            SetSelected_Topup(Number(topup));
            SetTotal_Count(Number(last_total_count_));

            SetR_Detail(Detail);

            let cur_page = await Return_Page_Settings(Number(last_total_count_));
            // console.log(Number(cur_page));

            SetTotal_Page(Number(cur_page));
            SetCurrent_Page(Number(cur_page));
                
            // console.log("topup : "+topup+" last_total_count_: "+last_total_count_+" cur_page: "+cur_page+" Detail: "+Detail);

            // console.log("Detail: ");
            // console.log(Detail);

            Current_Page_Detail(Number(cur_page), Detail, last_total_count_, topup);
         }
        catch(error) {
            console.log(error);
                       
            SetSelected_Topup(Number(0));
            SetTotal_Count(Number(0));

            SetTotal_Page(Number(0));
            SetCurrent_Page(Number(0));

            SetR_Detail([]);
        }
    }    

    //-----------

    const Total_Roi_Count_Btn_Clicked = async(no) => {
        try {

            SetCur_Roi_Selected(Number(no));
            SetCur_Roi_Selected_Total_Days(Total_Roi_Count_Detail[(no-1)].total_roi_days);
            SetCur_Roi_Selected_Claimable(Total_Roi_Count_Detail[(no-1)].claimabe_amt);

           // console.log("props.ID_Type_: ");
           // console.log(props.ID_Type_);

            if(props.ID_Type_ === true) {

                let cur_timestamp = await GetTimestamp();
                let cur_date_timestamp = await Convert_DateTime_Timestamp_Into_Date_Timestamp(cur_timestamp);

                let Roi_Claim_Limit_Date_Timestamp = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetRoi_Claim_Limit_Date_Timestamp",
                    args: [props.ID_, Number(no)]
                });

                if(Total_Roi_Count_Detail[(no-1)].claimabe_amt > Number(0)) {
                  // console.log("Total_Roi_Count_Detail[(no-1)].claimabe_amt: ");
                  // console.log(Total_Roi_Count_Detail[(no-1)].claimabe_amt);
                  // console.log(" ");
                  // console.log("Number(cur_date_timestamp) >= Number(Roi_Claim_Limit_Date_Timestamp)");
                  // console.log(Number(cur_date_timestamp));
                  // console.log(" >= ");
                  // console.log(Number(Roi_Claim_Limit_Date_Timestamp));

                    if(Total_Roi_Count_Detail[(no-1)].claimabe_amt >= Number(1)) {
                        SetShould_Disable(false);
                    }
                    else if(Number(cur_date_timestamp) >= Number(Roi_Claim_Limit_Date_Timestamp)) {
                        SetShould_Disable(false);
                    }
                    else {
                        SetShould_Disable(true);
                    }
                }
                else if(Total_Roi_Count_Detail[(no-1)].claimabe_amt === Number(0)) {
                    SetShould_Disable(true);
                }
            }
            else if(props.ID_Type_ === false) {
                SetShould_Disable(true);
            }
        }
        catch(error) {
            console.log(error);
            
            SetCur_Roi_Selected(Number(0));
            SetCur_Roi_Selected_Total_Days(Number(0));
            SetCur_Roi_Selected_Claimable(Number(0));
            
            SetShould_Disable(true);

        }
    }
    const Claim_Click = async() => {
        try {
            props.SetLoadingModal(true, true);
            if(window.ethereum) {
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });
        
                // console.log("WalletClient");
                // console.log(walletClient);
                

                props.SetLoadingModal(true, false);

                // let cur_timestamp = await GetTimestamp();
                    
                try {
                    let withdraw_roi_request = await walletClient.writeContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "Claim_Roi",
                        args: [props.ID_, Number(Cur_Roi_Selected)]//, Number(cur_timestamp)],
                    });

                    props.SetLoadingModal(true, true);
                    //console.log("withdraw_roi_request: ");
                    //console.log(withdraw_roi_request);
                
                    const withdraw_roi_request_waiting = await client.waitForTransactionReceipt({confirmations: 5, hash: withdraw_roi_request});
            
                    if(withdraw_roi_request_waiting.status === "success") {
                        props.SetLoadingModal(false, false);
                        props.showAlert("Roi "+Cur_Roi_Selected+" Claimed!...", "success", true);
                        setTimeout(() => {
                            //---SetLoading---
                            props.ReLoad();

                            if(Claim_is_Click_So_ReLoad === true) {
                                SetClaim_is_Click_So_ReLoad(false);                            
                            }
                            else if(Claim_is_Click_So_ReLoad === false) {
                                SetClaim_is_Click_So_ReLoad(true);                            
                            }
                        }, [2000]);
                    }
                    else {
                        props.SetLoadingModal(false, false);
                        props.showAlert("Roi "+Cur_Roi_Selected+" Claim Transaction Reverted!...", "danger", true);
                    }    
                }    
                catch(error) {
                    props.SetLoadingModal(false, false);
                    props.showAlert("Roi "+Cur_Roi_Selected+" Claim Transaction Reverted!...", "danger", true);
                }             
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please Use Through DAPPS!...", "warning", false);
            }            
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }


    useEffect(() => {
        const Load = async() => {
            try {
                
               // console.log("Roi Income Form: props.ID_: " + props.ID_);
               // console.log("Roi Income Form: props.Is_State_Change: " + props.Is_State_Change);


                SetIs_Selected_Roi_Completed(false);

                SetRoi_Is(Loading_Component());
                SetRoi_Detail([]);
                
                SetRoi_Count_Is("");
                SetRoi_Count_Detail([]);

                let Arr = [];
                let Roi_Arr = [];

                let ID_Count = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetID_Count",
                    args: [props.ID_]
                });

                SetTotal_Topup(Number(ID_Count));

                //console.log("ID_Total_TopUp: " + ID_Total_TopUp);

                let Total_Roi_Detail = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetTotal_Roi_Detail",
                    args: [props.ID_, Number(1), Number(ID_Count)]
                })

                for(let i = 1; i <= ID_Count; i++) {

                   // console.log(" ");
                   // console.log(" ----------------- ");
                   // console.log(" ");

                    let ID_Count_Pack_Amt = await client.readContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "GetID_Count_Pack_Amt",
                        args: [props.ID_, Number(i)]
                    });

                    let Last_Time_Claimed_Date_Timestamp = await client.readContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "GetLast_Time_Claimed_Date_Timestamp",
                        args: [props.ID_, Number(i)]
                    });
                    let Last_Date_Timestamp_Of_Roi = await client.readContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "GetRoi_Claim_Limit_Date_Timestamp",
                        args: [props.ID_, Number(i)]
                    });


                   // console.log("  ");
                   // console.log("Last_Time_Claimed_Date_Timestamp: " + Last_Time_Claimed_Date_Timestamp);
                    let Last_Time_Claimed_Date_Timestamp_datetime_ = await GetDateTime(Last_Time_Claimed_Date_Timestamp);
                   // console.log("Last_Time_Claimed_Date_Timestamp_datetime_: " + Last_Time_Claimed_Date_Timestamp_datetime_); 
                   // console.log("  ");
                   // console.log("Last_Date_Timestamp_Of_Roi: " + Last_Date_Timestamp_Of_Roi);
                    let Last_Date_Timestamp_Of_Roi_datetime_ = await GetDateTime(Last_Date_Timestamp_Of_Roi);
                   // console.log("Last_Date_Timestamp_Of_Roi_datetime_: " + Last_Date_Timestamp_Of_Roi_datetime_); 
                   // console.log("  ");

                    let cur_full_timestamp = await GetTimestamp();
                   // console.log("cur_Full_Timestamp:               " + cur_full_timestamp);
                    let Cur_Date_Timestamp = await Convert_DateTime_Timestamp_Into_Date_Timestamp(cur_full_timestamp);
                   // console.log("Cur_Date_Timestamp:               " + Cur_Date_Timestamp);
                    let add_one_day_to_start_from = await addDaysToSolidityExpiry(Number(Last_Time_Claimed_Date_Timestamp), Number(1));
                   // console.log("add_one_day_to_start_from:        " + add_one_day_to_start_from);

                   // console.log("  ");                    

                    let cur_full_timestamp_datetime_ = await GetDateTime(cur_full_timestamp);
                   // console.log("cur_full_timestamp_datetime_: " + cur_full_timestamp_datetime_);                                        
                    let Cur_Date_Timestamp_datetime_ = await GetDateTime(Cur_Date_Timestamp);
                   // console.log("Cur_Date_Timestamp_datetime_: " + Cur_Date_Timestamp_datetime_);
                    let add_one_day_to_start_from_datetime_ = await GetDateTime(add_one_day_to_start_from);
                   // console.log("add_one_day_to_start_from_datetime_: " + add_one_day_to_start_from_datetime_);


                   // console.log(" ");
                   // console.log(" ----------------- ");
                   // console.log(" ");

                    let claimabe_amt_ = BigInt(0);
                   // console.log(claimabe_amt_);

                    let status_ = "---";


                    if(Number(Last_Time_Claimed_Date_Timestamp) === Number(Last_Date_Timestamp_Of_Roi)) {
                        claimabe_amt_ = BigInt(0);
                        status_ = "COMPLETED";
                    }
                    else if(Number(Last_Time_Claimed_Date_Timestamp) < Number(Last_Date_Timestamp_Of_Roi)) {
                        status_ = "RUNNING";
                        if(Number(Cur_Date_Timestamp) === Number(Last_Time_Claimed_Date_Timestamp)) {
                            claimabe_amt_ = BigInt(0);
                        }
                        else if(Number(Cur_Date_Timestamp) > Number(Last_Time_Claimed_Date_Timestamp)) {
                        
                            if(Number(Cur_Date_Timestamp) >= Number(Last_Date_Timestamp_Of_Roi)) {
                                Cur_Date_Timestamp = Number(Last_Date_Timestamp_Of_Roi);
                            }
                            else if(Number(Cur_Date_Timestamp) < Number(Last_Date_Timestamp_Of_Roi)) {
                                Cur_Date_Timestamp = Number(Cur_Date_Timestamp);
                            }

                            do {
                                if(add_one_day_to_start_from <= Cur_Date_Timestamp) {
                                   // console.log(add_one_day_to_start_from);
                                    claimabe_amt_ += BigInt(BigInt(ID_Count_Pack_Amt) * BigInt(1) / BigInt(100));
                                    add_one_day_to_start_from = await addDaysToSolidityExpiry(Number(add_one_day_to_start_from), Number(1));
                                }
                                else if(add_one_day_to_start_from > Cur_Date_Timestamp) {
                                    break;
                                }

                            }   
                            while(true);
                        }
                    }

                   // console.log(claimabe_amt_);

                    Arr.push({
                        no: Number(Total_Roi_Detail[0][i]),
                        days: Number(Total_Roi_Detail[1][i]),
                        daily: "1%",
                        claimable: Format_Usdt(BigInt(claimabe_amt_)),
                        claimed: Format_Usdt(BigInt(Total_Roi_Detail[2][i])),
                        balance: Format_Usdt(BigInt(Total_Roi_Detail[3][i])),
                        status: status_,

                        
                        cur_date_timestamp_: Cur_Date_Timestamp,
                        last_time_claimed_date_timestamp_: Last_Time_Claimed_Date_Timestamp,
                        last_date_timestamp_of_roi_: Last_Date_Timestamp_Of_Roi
                    });

                    //----Roi_Add_Detaii----\\

                    Roi_Arr.push({
                        no: Number(Total_Roi_Detail[0][i]),
                        total_roi_days: Number(Total_Roi_Detail[1][i]),
                        claimable_amt_deci: BigInt(claimabe_amt_),
                        claimabe_amt: Number(Format_Usdt(BigInt(claimabe_amt_)))
                    });
                }

                SetRoi_Is("");
                SetRoi_Detail(Arr);

                SetRoi_Count_Is("");
                SetRoi_Count_Detail([]);

                //----Roi_Card_Area----\\

                SetTotal_Roi_Count(Number(ID_Count));
                SetTotal_Roi_Count_Detail(Roi_Arr);

                await Total_Roi_Count_Btn_Clicked(Number(ID_Count));
            }
            catch(error) {
                console.log(error);
                
                SetSelected_Topup(Number(0));
                SetTotal_Count(Number(0));
    
                SetIs_Selected_Roi_Completed(false);

                SetTotal_Page(Number(0));
                SetCurrent_Page(Number(0));

                SetR_Detail([]);

                SetRoi_Is("");
                SetRoi_Detail([]);

                SetRoi_Count_Is("");
                SetRoi_Count_Detail([]);

            }
        }
        Load();
        Total_Roi_Count_Btn_Clicked(Number(Total_Topup));

    }, [props.ID_, props.address, props.Is_State_Change, Claim_is_Click_So_ReLoad]);

    useEffect(() => {
        Total_Roi_Count_Btn_Clicked(Number(Total_Topup));
    }, [Total_Roi_Count_Detail, Claim_is_Click_So_ReLoad]);

    return (
        <>
            <div class="recent-grid">
                <div class="projects">
                    <div class="card-table">
                        <div class="card-level-header">
                            <span><h3>Roi Activity</h3></span>
                            <div class="level-btn scroll-bar"> 
                                {/* <button>All<span class=""></span></button>    */}
                                {
                                    Total_Roi_Count_Detail.map((data) => {
                                        return (
                                            <>
                                                <button onClick={() => {Total_Roi_Count_Btn_Clicked(data.no)}}><span>{data.no}</span></button>  
                                            </>
                                        );
                                    })
                                }          
                            </div>
                        </div>
                        <div class="table-cards">
                            <div class="table-card-single">
                                <div class="card-single-header">
                                    <h3>Roi Bonus ++</h3>
                                    <div class="roi-count">
                                        <h2>{Cur_Roi_Selected}</h2>
                                    </div>
                                </div> 
                                <div class="card-bodys-miiddle">
                                    <div class="card-calc">
                                        <h3>Days</h3>
                                        <div class="grid-detail">
                                            <span>{Cur_Roi_Selected_Total_Days}</span>
                                        </div> 
                                    </div>
                                    <div class="card-calc">
                                        <h3>Claimable</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>{Cur_Roi_Selected_Claimable}</span>
                                        </div> 
                                    </div>
                                </div>
                                <div class="card-single-last">
                                    {
                                        Should_Disable === true ? (
                                            <>
                                                <button style={{background: "grey"}}>Claim</button>
                                            </>
                                        ) : Should_Disable === false ? (
                                            <>
                                                <button onClick={() => {Claim_Click();}}>Claim</button>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="table-top">
                            <span><h3>All Roi Activity</h3></span>
                        </div>
                        <div class="card-body scroll-bar">
                            <div class="table-responsive">
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Sr.</td>
                                            <td>Days</td>
                                            <td>Daily %</td>
                                            <td>Claimable</td>
                                            <td>Claimed</td>
                                            <td>Balance</td>
                                            <td>Status</td>
                                            <td>Detail</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Roi_Is === "" ? (
                                                <>
                                                    {
                                                        Roi_Detail.map((data) => {
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td>{data.no}</td>
                                                                        <td>{data.days}</td>
                                                                        <td>{data.daily}</td>
                                                                        <td><span class="td-space">$</span>{data.claimable}</td>
                                                                        <td><span class="td-space">$</span>{data.claimed}</td>
                                                                        <td><span class="td-space">$</span>{data.balance}</td>
                                                                        <td>{data.status}</td>
                                                                        <td><div class="detail" onClick={() => {Roi_Count_Clicked(data.no, data.days, data.cur_date_timestamp_, data.last_time_claimed_date_timestamp_)}}><a>Detail</a></div></td>
                                                                    </tr>
                                                                </>
                                                            );
                                                        })                                                        
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Roi_Is}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* <div class="pre-next-btn">
                                <button>&larr; Pre </button>
                                <div class="show-rows">20/100</div>
                                <button>Next &rarr; </button>
                        </div> */}
                        
                        <div class="table-top">
                            <span><h3>Roi Activity</h3></span>
                            <span><h4>{Selected_Topup}</h4></span>
                        </div>
                        <div class="card-body scroll-bar">
                            <div class="table-responsive">
                                <table width="100%">
                                    <thead>
                                    <tr>
                                        <td>Days</td>
                                        <td>Daily %</td>
                                        <td>Claimable</td>
                                        <td>Roi-Date</td>
                                        <td>Status</td>    
                                        {/* <td>Claimed-Date</td> */}
                                    </tr>
                                    </thead>
                                    <tbody>                                                                                                                                      
                                        {
                                            Roi_Count_Is === "" ? (
                                                <>
                                                    {
                                                        Roi_Count_Detail && Roi_Count_Detail.length > 0 ? (                                                        
                                                            Roi_Count_Detail.map((data) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{data.sr}</td>
                                                                            <td>1%</td>
                                                                            <td><span class="td-space">$</span>{data.claimable}</td>
                                                                            <td>{data.datetime}</td>
                                                                            <td>{data.status}</td>
                                                                        </tr>          
                                                                    </>
                                                                );
                                                            }) 
                                                        ) : (
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td style={{ textAlign: 'center' }}>There's No Record</td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Roi_Count_Is}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="pre-next-btn">
                            <button onClick={() => {Pre();}}>&larr; Pre </button>
                            <div class="show-rows">{Current_Page} / {Total_Page}</div>
                            <button onClick={() => {Next();}}>Next &rarr; </button>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}

{/*----Direct_Income--------*/}

export function Refferal_Income_Form(props) {

    const [Ref_Claimed, SetRef_Claimed] = useState(Number(0));
    const [Ref_Claimable, SetRef_Claimable] = useState(Number(0));

    const [Ref_Btn_Disabled, SetRef_Btn_Disabled] = useState(true);


    //-----//
    
    const [Total_Page, SetTotal_Page] = useState(Number(0));
    const [Current_Page, SetCurrent_Page] = useState(Number(0));

    const [Direct_Downline_Is_Loading, SetDirect_Downline_Is_Loading] = useState("");
    const [Direct_Downline_Detail, SetDirect_Downline_Detail] = useState([]);
    
    
    //-----//

    const [Direct_Downline_ID_Is_Loading, SetDirect_Downline_ID_Is_Loading] = useState("");
    const [Direct_Downline_ID_Detail, SetDirect_Downline_ID_Detail] = useState([]);

    const [Selected_ID_Num, SetSelected_ID_Num] = useState(Number(0));

    //-----//
    
    const [L_Total_Page, SetL_Total_Page] = useState(Number(0));
    const [L_Current_Page, SetL_Current_Page] = useState(Number(0));

    const [L_ID_, SetL_ID_] = useState("");
    const [L_UserName_, SetL_UserName_] = useState("");
    const [L_TopUp_Cou_, SetL_TopUp_Cou_] = useState(Number(0));
    const [L_TopUp_Rec_Cou_, SetL_TopUp_Rec_Cou_] = useState(Number(0));

    const [Direct_Downline_ID_Count_Is_Loading, SetDirect_Downline_ID_Count_Is_Loading] = useState("");
    const [Direct_Downline_ID_Count_Detail, SetDirect_Downline_ID_Count_Detail] = useState([]);

    const [Selected_ID_TopUp, SetSelected_ID_TopUp] = useState(Number(0));

    ///

    const Claim_Ref = async() => {
        try {
            props.SetLoadingModal(true, true);
            if(window.ethereum) {
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });
        
                // console.log("WalletClient");
                // console.log(walletClient);
                

                props.SetLoadingModal(true, false);

                // let cur_timestamp = await GetTimestamp();
                    
                try {
                    let withdraw_ref_request = await walletClient.writeContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "Claim_Wallet_Reward",
                        args: [props.ID_]//, Number(cur_timestamp)],
                    });

                    props.SetLoadingModal(true, true);
                    //console.log("withdraw_ref_request: ");
                    //console.log(withdraw_ref_request);
                
                    const withdraw_ref_request_waiting = await client.waitForTransactionReceipt({confirmations: 5, hash: withdraw_ref_request});
            
                    if(withdraw_ref_request_waiting.status === "success") {
                        props.SetLoadingModal(false, false);
                        props.showAlert("Refferal Income Claimed!...", "success", true);
                        setTimeout(() => {
                            //---SetLoading---
                            props.ReLoad();
                        }, [2000]);
                    }
                    else {
                        props.SetLoadingModal(false, false);
                        props.showAlert("Refferal Income Claim Transaction Reverted!...", "danger", true);
                    }    
                }    
                catch(error) {
                    props.SetLoadingModal(false, false);
                    props.showAlert("Refferal Income Claim Transaction Reverted!...", "danger", true);
                }             
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please Use Through DAPPS!...", "warning", false);
            }            
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }

    ///

    const L_Current_Page_Detail = async(cur_page, id_, topup_count_, username_, total_rec_cou_) => {
        try {            
            SetL_Current_Page(cur_page);
            
            SetDirect_Downline_ID_Count_Is_Loading(Loading_Component());
            SetDirect_Downline_ID_Count_Detail([]);
            
            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            //console.log(from + " from");
            //console.log(to + " to");

            let Arr = [];

          // console.log("Ref_ID_Count_Detail function's Area---")
          // console.log("props.ID_: " + props.ID_);
          // console.log(" id_: " + id_);
          // console.log(" topup_count_: " + Number(topup_count_));
          // console.log(" from: " + Number(from));
          // console.log(" to: " + Number(to));
          // console.log("L_TopUp_Rec_Cou_: "+ Number(total_rec_cou_));//L_TopUp_Rec_Cou_));
          // console.log(" ");


            let Ref_ID_Count_Detail = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetRef_ID_Count_Detail",
                args: [props.ID_, id_, Number(topup_count_), Number(from), Number(to)]
            });
          // console.log("Ref_ID_Count_Detail: ");
          // console.log(Ref_ID_Count_Detail);

            for(let i = 1; i <= 20; i++) {

                // if(BigInt(Ref_ID_Count_Detail[2][i]) === BigInt("0000000000000000000")) {
                //     break;
                // }    
                if(Number(Ref_ID_Count_Detail[0][i]) > Number(total_rec_cou_)) {//L_TopUp_Rec_Cou_)) {
                    break;
                }    

                Arr.push({
                    sr: Number(Ref_ID_Count_Detail[0][i]),
                    id: Ref_ID_Count_Detail[1][i],
                    username: username_,
                    earn: Format_Usdt(BigInt(Ref_ID_Count_Detail[2][i])),
                    datetime: Format_UTC(Number(Ref_ID_Count_Detail[3][i]))
                }); 
            }
            
            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail(Arr);
        }
        catch(error) {
            console.log(error);
            
            SetSelected_ID_TopUp(Number(0));

            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);
        }
    }

    const L_Next = async() => {
        let nextpage = Number(Number(L_Current_Page) + Number(1));
        if(Number(nextpage) > Number(L_Total_Page)) {}
        else if(Number(nextpage) <= Number(L_Total_Page)) {
            L_Current_Page_Detail(nextpage, L_ID_, Number(L_TopUp_Cou_), L_UserName_, L_TopUp_Rec_Cou_);
        }
    }
    const L_Pre = async() => {
        let prepage = Number(Number(L_Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {}
        else if(Number(prepage) >= Number(1)) {
            L_Current_Page_Detail(prepage, L_ID_, Number(L_TopUp_Cou_), L_UserName_, L_TopUp_Rec_Cou_);
        }
    }

    ///

    const ID_Count_Detail = async(no_, id_, username_, topup_rec_count_) => {
        try {   

            SetSelected_ID_TopUp(Number(no_));
          // console.log("topup_count_/no_");
          // console.log(Number(no_));
            
            SetL_ID_(id_);
            SetL_UserName_(username_);
            SetL_TopUp_Cou_(Number(no_));
            SetL_TopUp_Rec_Cou_(Number(topup_rec_count_));

            
            let cur_page = await Return_Page_Settings(Number(topup_rec_count_));
            //console.log(Number(cur_page));

            SetL_Total_Page(Number(cur_page));
            SetL_Current_Page(Number(cur_page));

            L_Current_Page_Detail(Number(cur_page), id_, no_, username_, Number(topup_rec_count_));  

        }
        catch(error) {
            console.log(error);

            SetSelected_ID_TopUp(Number(0));

            SetL_ID_("");
            SetL_UserName_("");
            SetL_TopUp_Cou_(Number(0));
            SetL_TopUp_Rec_Cou_(Number(0));

            
            SetL_Total_Page(Number(0));
            SetL_Current_Page(Number(0));
        }
    }

    ///

    const ID_Detail = async(no_, id_, username_, topup_) => {
        try {   

            SetSelected_ID_Num(Number(no_));
            
            SetDirect_Downline_ID_Is_Loading(Loading_Component());
            SetDirect_Downline_ID_Detail([]);

            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);

            let Arr = [];

                

            let Ref_ID_Detail = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetRef_ID_Detail",
                args: [props.ID_, id_, Number(1), Number(topup_)]
            });

          // console.log("Ref_ID_Detail: ");
          // console.log(Ref_ID_Detail);

            for(let i = 1; i <= topup_; i++) {

                let topup_amt_ = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetID_Count_Pack_Amt",
                    args: [id_, Number(topup_)]
                });
            
                Arr.push({
                    sr: Number(Ref_ID_Detail[0][i]),
                    id: Ref_ID_Detail[1][i],
                    username: username_,
                    topup_amt: Format_Usdt(BigInt(topup_amt_)),
                    topup_rec_count: Number(Ref_ID_Detail[2][i]),
                    total_earn: Format_Usdt(BigInt(Ref_ID_Detail[3][i]))
                });
            } 
            
            SetDirect_Downline_ID_Is_Loading("");
            SetDirect_Downline_ID_Detail(Arr);
            
            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);
        }
        catch(error) {
            console.log(error);

            SetSelected_ID_Num(Number(0));

            SetDirect_Downline_ID_Is_Loading("");
            SetDirect_Downline_ID_Detail([]);
            
            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);
        }
    }

    ///

    const Current_Page_Detail = async(cur_page) => {
        try {            
            SetCurrent_Page(cur_page);

            SetDirect_Downline_ID_Is_Loading(Loading_Component());
            SetDirect_Downline_ID_Detail([]);

            SetDirect_Downline_Is_Loading("");
            SetDirect_Downline_Detail([]);

            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);
            
            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            //console.log(from + " from");
            //console.log(to + " to");

            let Arr = [];

            let Ref_Detail = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetRef_Detail",
                args: [props.ID_, Number(from), Number(to)]
            });

            for(let i = 1; i <= 20; i++) {

                if(Ref_Detail[1][i] === "") {
                    break;
                }    

                Arr.push({
                    sr: Number(Ref_Detail[0][i]),
                    id: Ref_Detail[1][i],
                    username: Ref_Detail[2][i],
                    topup_count: Number(Ref_Detail[3][i]),
                    total_earn: Format_Usdt(BigInt(Ref_Detail[4][i])),
                });  
            }
            
            SetDirect_Downline_Is_Loading("");
            SetDirect_Downline_Detail(Arr);
            
            SetDirect_Downline_ID_Is_Loading("");
            SetDirect_Downline_ID_Detail([]);

            SetDirect_Downline_ID_Count_Is_Loading("");
            SetDirect_Downline_ID_Count_Detail([]);
        }
        catch(error) {
            console.log(error);
            
            SetDirect_Downline_Is_Loading("");
            SetDirect_Downline_Detail([]);
            
            SetDirect_Downline_ID_Is_Loading("");
            SetDirect_Downline_ID_Detail([]);
        }
    }

    const Next = async() => {
        let nextpage = Number(Number(Current_Page) + Number(1));
        if(Number(nextpage) > Number(Total_Page)) {}
        else if(Number(nextpage) <= Number(Total_Page)) {
            Current_Page_Detail(nextpage);
        }
    }
    const Pre = async() => {
        let prepage = Number(Number(Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {}
        else if(Number(prepage) >= Number(1)) {
            Current_Page_Detail(prepage);
        }
    }

    useEffect(() => {
        const Load = async() => {
            try {   
           
               // console.log("Refferal Income Form: props.ID_: " + props.ID_);
               // console.log("Refferal Income Form: props.Is_State_Change: " + props.Is_State_Change);
            
                let Wallet_Reward = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetWallet_Reward",
                    args: [props.ID_]
                }); 

                let Total_Wallet_Claimed_Amt = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetTotal_Wallet_Claimed_Amt",
                    args: [props.ID_]
                }); 

                SetRef_Claimed(Format_Usdt(BigInt(Total_Wallet_Claimed_Amt)));
                SetRef_Claimable(Format_Usdt(BigInt(Wallet_Reward)));
                
                if(BigInt(Wallet_Reward) > BigInt(0)) {
                    if(BigInt(Wallet_Reward) >= BigInt(1000000000000000000)) {
                        SetRef_Btn_Disabled(false);
                    }
                    else {
                        SetRef_Btn_Disabled(true);
                    }
                }
                else {
                    SetRef_Btn_Disabled(true);
                }


                let Direct_Count = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetRef_Count",
                    args: [props.ID_]
                });  
                
                let cur_page = await Return_Page_Settings(Number(Direct_Count));
                //console.log(Number(cur_page));

                SetTotal_Page(Number(cur_page));
                SetCurrent_Page(Number(cur_page));

                Current_Page_Detail(Number(cur_page));  
            }
            catch(error) {
                console.log(error);
                
                SetRef_Claimed(Format_Usdt(BigInt(0)));
                SetRef_Claimable(Format_Usdt(BigInt(0)));
                
                SetRef_Btn_Disabled(true);
            }
        }
        Load();
    }, [props.ID_, props.address, props.Is_State_Change]);


    return (
        <>
            <div class="recent-grid">
                <div class="projects">
                    <div class="card-table">
                        <div class="table-top">
                            <span><h3>Refferal Activity</h3></span>
                        </div>
                        <div class="table-cards">
                            <div class="table-card-single">
                                <div class="card-single-header">
                                    <h3>Referral Bonus</h3>
                                    {/* <div class="roi-count">
                                        <h2>1</h2>
                                    </div> */}
                                </div> 
                                <div class="card-bodys-miiddle">
                                    <div class="card-calc">
                                        <h3>Claimed</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>{Ref_Claimed}</span>
                                        </div> 
                                    </div>
                                    <div class="card-calc">
                                        <h3>Claimable</h3>
                                        <div class="grid-detail">
                                            <span>$</span>
                                            <span>{Ref_Claimable}</span>    
                                        </div> 
                                    </div>
                                </div>
                                <div class="card-single-last">
                                    {
                                        Ref_Btn_Disabled === true ? (
                                            <>
                                                <button style={{background: 'grey'}}>Claim<span></span></button>
                                            </>
                                        ) : Ref_Btn_Disabled === false ? (
                                            <>
                                                <button onClick={() => {Claim_Ref();}}>Claim<span></span></button>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </div>
                            </div>
                        </div>


                        <div class="table-top">
                            <span><h3>All Refferal Team</h3></span>
                        </div>
                        <div class="card-body scroll-bar">
                            <div class="table-responsive">
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Sr.</td>
                                            <td>ID</td>
                                            <td>User Name</td>
                                            <td>Top-Up Count</td>
                                            <td>Earn</td>   
                                            <td>Details</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Direct_Downline_Is_Loading === "" ? (
                                                <>
                                                    {
                                                        Direct_Downline_Detail && Direct_Downline_Detail.length > 0 ? (                                                        
                                                            Direct_Downline_Detail.map((data) => {
                                                                return (
                                                                    <>
                                                                        <tr key={data.id}>
                                                                            <td>{data.sr}</td>
                                                                            <td>{data.id}</td>
                                                                            <td>{data.username}</td>
                                                                            <td>{data.topup_count}</td>
                                                                            <td><span class="td-space">$</span>{data.total_earn}</td>
                                                                            <td><div class="detail"><a onClick={() => {ID_Detail(data.sr, data.id, data.username, data.topup_count)}}>Detail</a></div></td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td style={{ textAlign: 'center' }}>There's No Record</td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Direct_Downline_Is_Loading}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="pre-next-btn">
                            <button onClick={() => {Pre();}}>&larr; Pre </button>
                            <div class="show-rows">{Current_Page} / {Total_Page}</div>
                            <button onClick={() => {Next();}}>Next &rarr; </button>
                        </div>


                        <div class="table-top">
                            <span><h3>Refferal</h3></span>
                            <span><h4>{Selected_ID_Num}</h4></span>
                        </div>
                        <div class="card-body scroll-bar">
                            <div class="table-responsive">
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Sr.</td>
                                            <td>ID</td>
                                            <td>User Name</td>
                                            <td>Top-Up Amount </td>
                                            <td>Top-Up Recieved Count</td>
                                            <td>Total Earn</td>   
                                            <td>Detail</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Direct_Downline_ID_Is_Loading === "" ? (
                                                <>
                                                    {
                                                        Direct_Downline_ID_Detail && Direct_Downline_ID_Detail.length > 0 ? (                                                        
                                                            Direct_Downline_ID_Detail.map((data) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{data.sr}</td>
                                                                            <td>{data.id}</td>
                                                                            <td>{data.username}</td>
                                                                            <td><span class="td-space">$</span>{data.topup_amt}</td>
                                                                            <td>{data.topup_rec_count}</td>
                                                                            <td><span class="td-space">$</span>{data.total_earn}</td>
                                                                            <td>
                                                                                <div class="detail">
                                                                                    <a 
                                                                                        onClick={() => {ID_Count_Detail(data.sr, data.id, data.username, data.topup_rec_count)}}
                                                                                    >Detail</a>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td style={{ textAlign: 'center' }}>There's No Record</td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Direct_Downline_ID_Is_Loading}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* <div class="pre-next-btn">
                            <button>&larr; Pre </button>
                            <div class="show-rows">20/100</div>
                            <button>Next &rarr; </button>
                        </div> */}

                        <div class="table-top">
                            <span><h3>Refferal ID Selected Top-Up</h3></span>
                            <span><h4>{Selected_ID_TopUp}</h4></span>
                        </div>
                        <div class="card-body scroll-bar">
                            <div class="table-responsive">
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td>Sr.</td>
                                            <td>ID</td>
                                            <td>User Name</td>
                                            <td>Earn</td>   
                                            <td>Top-Up-Date</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Direct_Downline_ID_Count_Is_Loading === "" ? (
                                                <>
                                                    {
                                                        Direct_Downline_ID_Count_Detail && Direct_Downline_ID_Count_Detail.length > 0 ? (                                                        
                                                            Direct_Downline_ID_Count_Detail.map((data) => {
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{data.sr}</td>
                                                                            <td>{data.id}</td>
                                                                            <td>{data.username}</td>
                                                                            <td><span class="td-space">$</span>{data.earn}</td>
                                                                            <td>{data.datetime}</td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td style={{ textAlign: 'center' }}>There's No Record</td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Direct_Downline_ID_Is_Loading}</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>                        
                        <div class="pre-next-btn">
                            <button onClick={() => {L_Pre();}}>&larr; Pre </button>
                            <div class="show-rows">{L_Current_Page} / {L_Total_Page}</div>
                            <button onClick={() => {L_Next();}}>Next &rarr; </button>
                        </div>

                        <Refferal_Income_Claimed_Form ID_={props.ID_} address={props.address} Is_State_Change={props.Is_State_Change}/>

                    </div>
                </div>
            </div>
        </>
    );
}
function Refferal_Income_Claimed_Form(props) {

    
    const [Total_Page, SetTotal_Page] = useState(Number(0));
    const [Current_Page, SetCurrent_Page] = useState(Number(0));

    
    const [Direct_Income_Claimed_Is_Loading, SetDirect_Income_Claimed_Is_Loading] = useState("");
    const [Direct_Income_Claimed_Detail, SetDirect_Income_Claimed_Detail] = useState([]);


    const Current_Page_Detail = async(cur_page) => {
        try {            
            SetCurrent_Page(cur_page);

            SetDirect_Income_Claimed_Is_Loading(Loading_Component());
            SetDirect_Income_Claimed_Detail([]);
            
            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            //console.log(from + " from");
            //console.log(to + " to");

            let Arr = [];

            let ID_UserName_ = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetID_UserName",
                args: [props.ID_]
            });

            for(let i = from; i <= to; i++) {

                let Wallet_Claimed_Count_Amount = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetWallet_Claimed_Count_Amount",
                    args: [props.ID_, Number(i)]
                });

                if(BigInt(Wallet_Claimed_Count_Amount) === BigInt(0)) {
                    break;
                }   
                
                let Wallet_Claimed_Count_Amount_Timestamp = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetWallet_Claimed_Count_Amount_Timestamp",
                    args: [props.ID_, Number(i), BigInt(Wallet_Claimed_Count_Amount)]
                });

                Arr.push({
                    sr: Number([i]),
                    id: props.ID_,
                    username: ID_UserName_,
                    claimed_amt: Format_Usdt(BigInt(Wallet_Claimed_Count_Amount)),
                    claimed_date: Format_UTC(Number(Wallet_Claimed_Count_Amount_Timestamp)),
                });  
            }
            
            SetDirect_Income_Claimed_Is_Loading("");
            SetDirect_Income_Claimed_Detail(Arr);
            
        }
        catch(error) {
            console.log(error);

            SetCurrent_Page(Number(0));
            
            SetDirect_Income_Claimed_Is_Loading("");
            SetDirect_Income_Claimed_Detail([]);
        }
    }

    const Next = async() => {
        let nextpage = Number(Number(Current_Page) + Number(1));
        if(Number(nextpage) > Number(Total_Page)) {}
        else if(Number(nextpage) <= Number(Total_Page)) {
            Current_Page_Detail(nextpage);
        }
    }
    const Pre = async() => {
        let prepage = Number(Number(Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {}
        else if(Number(prepage) >= Number(1)) {
            Current_Page_Detail(prepage);
        }
    }

    useEffect(() => {
        const Load = async() => {
            try {   
           
                let Wallet_Claimed_Count = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetWallet_Claimed_Count",
                    args: [props.ID_]
                });  
                
                let cur_page = await Return_Page_Settings(Number(Wallet_Claimed_Count));
                //console.log(Number(cur_page));

                SetTotal_Page(Number(cur_page));
                SetCurrent_Page(Number(cur_page));

                Current_Page_Detail(Number(cur_page));  
            }
            catch(error) {
                console.log(error);
                
                SetTotal_Page(Number(0));
                SetCurrent_Page(Number(0));
            }
        }
        Load();
    }, [props.ID_, props.address, props.Is_State_Change]);


    return (
        <>
            <div class="table-top">
                <span><h3>Refferal Claimed</h3></span>
                <span><h4></h4></span>
            </div>
            <div class="card-body scroll-bar">
                <div class="table-responsive">
                    <table width="100%">
                        <thead>
                            <tr>
                                <td>Sr.</td>
                                <td>ID</td>
                                <td>User Name</td>
                                <td>Claimed-Amount</td>
                                <td>Claimed-Date</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Direct_Income_Claimed_Is_Loading === "" ? (
                                    <>
                                        {
                                            Direct_Income_Claimed_Detail && Direct_Income_Claimed_Detail.length > 0 ? (                                                        
                                                Direct_Income_Claimed_Detail.map((data) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td>{data.sr}</td>
                                                                <td>{data.id}</td>
                                                                <td>{data.username}</td>
                                                                <td><span class="td-space">$</span>{data.claimed_amt}</td>
                                                                <td>{data.claimed_date}</td>
                                                            </tr>
                                                        </>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td style={{ textAlign: 'center' }}>There's No Record</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            )
                                        }
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>{Direct_Income_Claimed_Is_Loading}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="pre-next-btn">
                <button onClick={() => {//Pre();

                }}>&larr; Pre </button>
                <div class="show-rows">{Current_Page} / {Total_Page}</div>
                <button onClick={() => {//Next();

                }}>Next &rarr; </button>
            </div>
        </>
    );
}

{/*----Team_Tree--------*/}

export function Team_Tree_Form(props) {

    const[TN0_UserName, SetTN0_UserName] = useState();
    const[TN0_ID, SetTN0_ID] = useState();
    const[TN0_Is, SetTN0_Is] = useState("Vacant");

    const[Total_Node, SetTotal_Node] = useState(Number(0));
    const[Detail_Arr, SetDetail_Arr] = useState([]);

    const Tree_Structure = async(id) => {
        try {

            SetTN0_UserName('');
            SetTN0_ID(Card_LC());
            
            SetTotal_Node(Number(0));
            SetDetail_Arr([]);

            let tn0_id_exist = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetID_Exist",
                args: [id]
            });
            
           // console.log("id: " + id);
           // console.log("tn0_id_exist: " + tn0_id_exist);

            if(tn0_id_exist === true) {
                let id_username = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetID_UserName",
                    args: [id]
                })
                SetTN0_UserName(id_username);
                SetTN0_ID(id);
                SetTN0_Is("Tree");


                let Upid_Node = await client.readContract({
                    address: Pro_Trader.address,
                    abi: Pro_Trader.abi,
                    functionName: "GetRef_Count",
                    args: [id]
                });
                //console.log("Upid_Node: " + Number(Upid_Node));

                let Arr = [];
                if(Number(Upid_Node) > 0) {
                    
                    let Tree_ID = await client.readContract({
                        address: Creator.address,
                        abi: Creator.abi,
                        functionName: "GetTree_ID",
                        args: [id, Number(Upid_Node)]
                    });

                    for(let i = 1; i <= Number(Upid_Node); i++) {
                        Arr.push({
                            no: Number(i),
                            id_: Tree_ID[0][i],
                            username_: Tree_ID[1][i],
                            add_: Tree_ID[2][i]
                        });
                    }
                }

                //console.log("Upid_Node: " + Number(Upid_Node));
                //console.log("Arr:");
                //console.log(Arr);
                SetTotal_Node(Number(Upid_Node));
                SetDetail_Arr(Arr);
            }
            else {
                SetTN0_UserName('');
                SetTN0_ID("");
                SetTN0_Is("Vacant");

                SetTotal_Node(Number(0));
                SetDetail_Arr([]);
            }
            
        }
        catch(error) {
            console.log(error);
            
            SetTN0_UserName("");
            SetTN0_ID("");
            SetTN0_Is("Vacant");

            SetTotal_Node(Number(0));
            SetDetail_Arr([]);
        }
    }

    useEffect(() => {
     // console.log("Team Tree Form: props.ID_: " + props.ID_);
     // console.log("Team Tree Form: props.Is_State_Change: " + props.Is_State_Change);
        if(props.ID_) {
            Tree_Structure(props.ID_);
        }
    }, [props.ID_, props.Is_State_Change]);
    

    return (
        <>
            <section id="Team Tree" class="view-tree"> 
                <div class="card-tree-header">
                    <span><h2>Team Tree</h2></span>            
                </div>
                {/* <div class="b-back-grid-short-tree"> 
                    <div class="b-back-grid-tree-blank">
                        <span></span>
                    </div>
                    <div class="b-back-grid-tree-id-search">
                        <div class="card-search">
                            <h4>Search id</h4>
                            <div class="search-box">
                                <label class="form-label" for="number"></label>
                                <input class="form-input" type="number" id="number" name="number" placeholder="Enter Only Number"/>
                            </div> 
                            <div class="card-search-id">
                                <span><button onClick={() => {Tree_Structure(props.ID_)}}>My ID</button></span>
                                <span><button>Search</button> </span>   
                            </div>
                        </div> 
                    </div>
                    <div class="b-back-grid-tree-blank">
                        <span></span>
                    </div>
                </div> */}
                <div class="hide-space"></div>  
                <div class="b-back-grid-short-tree"> 
                    <div class="b-back-grid-tree-blank">
                        <span></span>
                    </div>
                    <div class="b-back-grid-tree-id">
                        <div class="card-tree-id-main">1</div>
                        <div class="card-tree-user"><small>{TN0_UserName}</small></div>
                        <div class="tree-id">{TN0_ID}</div>
                        {/* <a class="tree-id-btn"><span>Tree</span></a> */}
                    </div>
                    <div class="b-back-grid-tree-blank">
                        <span></span>
                    </div>
                </div>
                <div class="hide-space"></div>
                <div class="b-back-grid-short-tree scroll-bar"> 
                    
                    {
                        Number(Total_Node) > Number(0) ? (
                            <>
                                {
                                    Detail_Arr.map((data) => {
                                        return (
                                            <>
                                                <div class="b-back-grid-tree-blank">
                                                    <span></span>
                                                </div>
                                                <div class="b-back-grid-tree-id">
                                                    <div class="card-tree-id-count">{data.no}</div>
                                                    <div class="card-tree-user"><small>{data.username_}</small></div>
                                                    <div class="tree-id">{data.id_}</div>
                                                    {/* <a class="tree-id-btn" onClick={() => {Tree_Structure(data.id_)}}><span>Tree</span></a> */}
                                                </div>
                                            </>
                                        );
                                    })
                                }
                            </>
                        ) : (
                            <>                            
                                <div class="b-back-grid-tree-blank">
                                    <span></span>
                                </div>
                                <div class="b-back-grid-tree-id">
                                    <div class="card-tree-id-count">1</div>
                                    <div class="card-tree-user"><small>Blank</small></div>
                                    <div class="tree-id">Blank</div>
                                    {/* <a class="tree-id-btn"><span>Tree</span></a> */}
                                </div>
                            </>                                    
                        )
                    } 
                    <div class="b-back-grid-tree-blank">
                        <span></span>
                    </div>
                </div>         
            </section> 
        </>
    );
}


{/*---------------------Before-Login---------*/}

{/*-----Refferal_Area-------------------------*/}

async function Generate_ID() {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for(let c = 1; c <= Number(9); c++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export async function Refferal_Detail(id, SetUpline_ID, showAlert, SetIsInput_Eligible, address_, SetWallet_Balance, open) {
    try {
        SetWallet_Balance(Loading_Component());
        
        // SetLoadingModal(true, true);
        let id_exist = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetID_Exist",
            args: [id]
        });
    
        if (id_exist === true) {
            SetUpline_ID(id);
            // SetLoadingModal(false, true); 
            let Is_Eligible_To_Refferal = await client.readContract({
                address: Pro_Trader.address,
                abi: Pro_Trader.abi,
                functionName: "GetIs_Eligible_To_Refferal",
                args: [id]
            });

            if(Is_Eligible_To_Refferal === true) {
                SetIsInput_Eligible(true);   

                open();   
                
                let Wall_Balance = await client.readContract({
                    address: Usdt_Token.address,
                    abi: Usdt_Token.abi,
                    functionName: "balanceOf",
                    args: [address_]
                });
                SetWallet_Balance(Format_Usdt(BigInt(Wall_Balance)));

            }
            else if(Is_Eligible_To_Refferal === false) {
                showAlert("Isnt Eligible To Refferal!.", "danger", true);
                SetIsInput_Eligible(false);
                SetWallet_Balance("0.00");
            }
        }
        else if (id_exist === false) {
            // SetLoadingModal(false, false);  
            showAlert("Doesn't Exist!.", "danger", true);
            SetIsInput_Eligible(false);
            SetWallet_Balance("0.00");
        }    

    }
    catch(error) {
        // SetLoadingModal(false, false);    
        SetIsInput_Eligible(false);
        SetWallet_Balance("0.00");
        console.log(error);
    }
}
export async function Refferal_SignUp(address, Upline_ID, username_, usdt_val_, showAlert, SetLoadingModal) {
    try {
        SetLoadingModal(true, true);
        let add_detail = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetAdd_Exist",
            args: [address]
        }); 

        // console.log("add_detail : " + add_detail);
    
        if (add_detail === true) {
            SetLoadingModal(false, false);
            showAlert("You Already Exist!...", "danger", true);
            window.location.replace(url);
        }
        else if (add_detail === false) {            
            SetLoadingModal(true, true);
            if (window.ethereum) {
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });
        
                //console.log("WalletClient");
                //console.log(walletClient);
                let id_;
                do{
                    id_ = await Generate_ID();
                    let id_exist = await client.readContract({
                        address: Pro_Trader.address,
                        abi: Pro_Trader.abi,
                        functionName: "GetID_Exist",
                        args: [id_]
                    });
                    if (id_exist === false) {
                        break;
                    }
                }
                while(true);

                //console.log("id_: " + id_);

               // console.log("usdt_val_: ");
               // console.log(usdt_val_);
                let usdt_amount = parseEther(String(usdt_val_));

               // console.log("usdt_amount: ");
               // console.log(usdt_amount);


                SetLoadingModal(true, true);
                // let User_Usdt_BalanceOf = await client.getBalance({address: address});

                let Usdt_Usdt_BalanceOf = await client.readContract({
                    address: Usdt_Token.address,
                    abi: Usdt_Token.abi,
                    functionName: "balanceOf",
                    args: [address]
                });
               // console.log(Number(Usdt_Usdt_BalanceOf));

               // console.log('address: ' + address + ' id_: ' + id_ + " Upline_ID: " + Upline_ID);

                
                // let cur_timestamp = await GetTimestamp();

                // //--

                if(BigInt(Usdt_Usdt_BalanceOf) >= BigInt(usdt_amount)) {
                    // console.log(BigInt(Usdt_Usdt_BalanceOf) + " is greater than " + BigInt(usdt_amount))
                    try {
                        SetLoadingModal(true, false);
                        
                        let usdt_request = await walletClient.writeContract({
                            address: Usdt_Token.address,
                            abi: Usdt_Token.abi,
                            functionName: "approve",
                            args: [Pro_Trader.address, BigInt(usdt_amount)],
                            
                            // maxPriorityFeePerGas: BigInt(60e9), // required minimum
                            // maxFeePerGas: BigInt(150e9),   
                        });

                        SetLoadingModal(true, true);
                        // console.log("usdt_request: ");
                        // console.log(usdt_request);
                    
                        const usdt_transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: usdt_request});
                
                        if(usdt_transaction.status === "success") {
                            SetLoadingModal(true, false);
                            
                            let activation_request = await walletClient.writeContract({
                                address: Pro_Trader.address,
                                abi: Pro_Trader.abi,
                                functionName: "Activate_ID",
                                args: [id_, username_, address, Upline_ID, BigInt(usdt_amount)]//, Number(cur_timestamp)],
                                // value: BigInt(core_amount),
                                
                                // maxPriorityFeePerGas: BigInt(60e9), // required minimum
                                // maxFeePerGas: BigInt(150e9),   
                            });

                            SetLoadingModal(true, true);
                            // console.log("activation_request: ");
                            // console.log(activation_request);
                        
                            const act_transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: activation_request});
                    
                            if(act_transaction.status === "success") {
                                SetLoadingModal(false, false);
                                showAlert("SignedUp!...", "success", true);
                                setTimeout(() => {
                                    window.location.replace(url);
                                }, [2000]);
                            }
                            else {
                                SetLoadingModal(false, false);
                                showAlert("Activation Transaction Reverted!...", "danger", true);
                            }
                        }
                        else {
                            SetLoadingModal(false, false);
                            showAlert("Usdt Approve Transaction Reverted!...", "danger", true);
                        }    
                    
                    }
                    catch(error) {
                        console.log(error);
                        SetLoadingModal(false, false); 
                        showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                else {
                    SetLoadingModal(false, false);
                    showAlert("Insufficient Balance!...", "danger", true);
                }
            }
            else {
                SetLoadingModal(false, false);
                showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
    
    }
    catch(error) {
        //console.log("Step Falied");
        console.log(error);
        //showAlert(error.toString(), "danger", false);
        SetLoadingModal(false, false);
    }
}

{/*-----Login_Area----------------------------*/}

export async function Login_Detail(address, SetIsLogin, showAlert) {
    try {
        let add_detail = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetAdd_Exist",
            args: [address]
        });
        
        if (add_detail === false) {
            SetIsLogin(false);
            showAlert("You Doesn't Exist!...", "danger", true);
        }
        else if (add_detail === true) {
            SetIsLogin(true);
            showAlert("Logined!...", "success", true);
        }
    }
    catch (error) {
        console.log(error);
    }
}


{/*----After_Login--------*/}

export async function Address_ID_Detail(address, SetID_, SetID_Type_, SetID_Cur_Topup, SetID_UserName) {
    try {
        let Add_ID = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetAdd_ID",
            args: [address]
        });
       // console.log(Add_ID);
        SetID_(Add_ID);

        let ID_Type = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetID_Type",
            args: [Add_ID]
        });

        let ID_Type_as = false;
        if(Number(ID_Type) === Number(1)) {
            ID_Type_as = false;
        }
        else if(Number(ID_Type) === Number(2) || Number(ID_Type) === Number(3)) {
            ID_Type_as = true;
        }

        SetID_Type_(ID_Type_as);

        let cur_topup_ = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetID_Count",
            args: [Add_ID]
        });
        SetID_Cur_Topup(Number(cur_topup_));

        let ID_UserName_ = await client.readContract({
            address: Pro_Trader.address,
            abi: Pro_Trader.abi,
            functionName: "GetID_UserName",
            args: [Add_ID]
        });
        SetID_UserName(ID_UserName_);
        
        // let User_BalanceOf = await client.getBalance({address: address});
        // SetWallet_Bal(Format_Core(User_BalanceOf));
    }
    catch(error) {
        console.log(error);
    }
}

//---
